import { BaseUser, CliUser } from "../types/users";
import { Itter } from "../utils/utils";

export function PHBaseUsers(length = 25) {
  return Itter<BaseUser>(length, i => ({
    avatar: "",
    color: "",
    displayName: "Example User",
    id: i.toString()
  }))
}

export const profileTabs = (user: CliUser, id: string) => {
  const tabs = [
    "badges",
    "igns"
  ]
  if (user.id === id) {
    tabs.push("roles")
    tabs.push("transactions")
    tabs.push("infractions")
  } else if (user.perms.isMod) {
    tabs.push("infractions")
  }
  return tabs
}